<template lang="html">
    <div class="container" id="text-page">
      <h1 class="mb-3 page-title">Preguntas frecuentes de los Clientes</h1>

      <!-- <div v-html="row"></div> -->

      <h5>¿ANLESA es quien vende los productos?</h5>
      <p>
        No. ANLESA es una plataforma que conecta a compradores con productores y vendedores locales. Cada producto es responsabilidad del vendedor afiliado.
      </p>

      <br />
      <h5>¿Cómo sé si un vendedor es confiable?</h5>
      <p>
        Puedes revisar su reputación, calificaciones de otros compradores y la información publicada en su perfil antes de realizar tu compra.
      </p>

      <br />
      <h5>¿A quién contacto si tengo un problema con mi pedido?</h5>
      <p>
        Debes comunicarte directamente con el vendedor desde tu cuenta. ANLESA no gestiona devoluciones ni garantías, pero puedes reportar irregularidades.
      </p>

      <br />
      <h5>¿Cuáles son los métodos de pago aceptados?</h5>
      <p>
        Los métodos de pago disponibles dependen de cada vendedor. Verás las opciones al momento de confirmar tu pedido.
      </p>

      <br />
      <h5>¿Puedo devolver un producto si no estoy satisfecho?</h5>
      <p>
        Depende de la política de devoluciones del vendedor. Te recomendamos leerla antes de realizar tu compra.
      </p>
    </div>
  </template>

  <script>
  export default {
    data(){
      return{
        row:null,
      }
    },

    methods: {
      getData: function(){
        axios.get(tools.url('/api/faqs_customers')).then((response)=>{
          this.row = response.data.body;
        }).catch((error)=>{
        })
      },
    },

    mounted(){
        this.getData();
    },
  }
  </script>
